/**
 * App shell breakpoints for main web (`DashboardLayout` / Sidebar / Header).
 * `SHELL_SIDEBAR_MIN_WIDTH` is the canonical 768px compact cutoff — import it
 * from here in `useIsMobile` and shell chrome (see `frontend/mobile-design.mdc`).
 */

/**
 * Compact / phone viewport and hamburger shell — also the Tailwind `md` cutoff.
 * Feature UIs (`useIsMobile`) and persistent sidebar share this value.
 */
export const SHELL_SIDEBAR_MIN_WIDTH = 768;

/**
 * Default expanded sidebar labels from this width up.
 * Between `SHELL_SIDEBAR_MIN_WIDTH` and this value, the rail defaults to icon-collapsed.
 */
export const SHELL_SIDEBAR_EXPANDED_MIN_WIDTH = 1024;
